import * as React from "react"
import { type VTableCellRenderProps } from "@digits-shared/components/UI/VirtualizedTable/vTableTypes"
import type { CellContext } from "@tanstack/react-table"

/*
  FUNCTION
*/
export function vTableCellRender<TData extends object>({
  Cell,
  LoaderCell,
}: VTableCellRenderProps<TData>) {
  return (info: CellContext<TData, unknown>) => {
    const { table, row } = info
    const loading = (!row.original && table.options?.meta?.loading) ?? false

    return loading ? (
      <LoaderCell />
    ) : (
      <Cell index={row.index} row={row} data={row.original} table={table} />
    )
  }
}
